'use strict';

var debugEnum = require('spotify-debug-tools/debug_enum');

/**
 * Standard methods for Hermes and HTTP requests.
 *
 * @enum {string}
 */
var Method = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  OPTIONS: 'OPTIONS'
};

module.exports = debugEnum(Method);
